import React, { Component } from 'react';
import { Accordion, AccordionItem } from 'react-sanfona';
import { FormattedNumber, injectIntl } from 'react-intl';
import moment from 'moment';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';
import Map from '../../../../components/Map';

import './styles.css';

class Ctes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLatitude: '',
      currentLongitude: '',
      showMapModal: false,
    };
  }
  calculateDeliveryDuration = (deliveryStart, deliveryEnd) => {
    if (!deliveryStart || !deliveryEnd) return 'Data de início ou fim da entrega não recebida.';
    const start = moment(deliveryStart);
    const end = moment(deliveryEnd);
    const diff = start.diff(end, 'seconds', true);
    return moment().startOf('day').add(diff, 's').format('HH:mm:ss');
  }
  _openMap = (currentLatitude, currentLongitude) => this.setState({
    currentLatitude,
    currentLongitude,
    showMapModal: true,
  })

  render() {
    const {
      currentManifest,
      intl,
    } = this.props;

    const {
      showMapModal,
      currentLatitude,
      currentLongitude,
    } = this.state;

    return (
      <div className="ManifestsInTransit__Ctes">
        <Accordion
          duration={0}
        >
          {currentManifest && currentManifest.deliveries.map(cte => (
            <AccordionItem
              key={cte.numCTe}
              className="NFTooltip__accordion-item"
              bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside padding"
              title={`CTE-${cte.numCTe}`}
              expanded
            >
              <div className="ManifestsInTransit--row">
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Data:</p>
                  <p className="ManifestsInTransit--p">{cte.dateCTe ? moment(cte.dateCTe).format('DD/MM/YYYY') : ''}</p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Data contratada:</p>
                  <p className="ManifestsInTransit--p">{cte.contractDate ? moment(cte.contractDate).format('DD/MM/YYYY') : ''}</p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Data fim:</p>
                  <p className="ManifestsInTransit--p">{cte.finishedDate ? moment(cte.finishedDate).format('DD/MM/YYYY') : ''}</p>
                </div>
              </div>
              <div className="ManifestsInTransit--row">
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">CNPJ emissor:</p>
                  <p className="ManifestsInTransit--p">{cte.cnpjEmit}</p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Valor do frete:</p>
                  <p className="ManifestsInTransit--p">R$ <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    currencyDisplay="symbol"
                    value={cte.freightCost}
                    useGrouping
                  />
                  </p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Agendado:</p>
                  <p className="ManifestsInTransit--p">{cte.scheduled ? 'Sim' : 'Não'}</p>
                </div>
              </div>
              <div className="ManifestsInTransit--row">
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Origem:</p>
                  <p className="ManifestsInTransit--p">{cte.origin.name} - {cte.origin.city}/{cte.origin.stateAbbr}</p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Total de documentos:</p>
                  <p className="ManifestsInTransit--p">{cte.totalDocuments}</p>
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Documentos finalizados:</p>
                  <p className="ManifestsInTransit--p">{cte.finishedDocuments}</p>
                </div>
              </div>
              <div className="ManifestsInTransit--row">
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Chegada no Local de Entrega</p>
                  {
                    (!cte.checkInLatitude || !cte.checkInLongitude)
                    ? (
                      <p className="ManifestsInTransit--p">Latitude ou longitude de chegada no local de entrega não recebida.</p>
                    )
                    : null
                  }
                  {
                    (cte.checkInLatitude || cte.checkInLongitude)
                    ? (
                      <Button
                        className="ManifestsInTransit-Ctes__Button"
                        disabled={(!cte.checkInLatitude || !cte.checkInLongitude)}
                        small
                        type="button"
                        skin="primary"
                        text="Visualizar no mapa"
                        onClick={() => this._openMap(cte.checkInLatitude, cte.checkInLongitude)}
                      />
                    )
                    : null
                  }
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Confirmação de Entrega</p>
                  {
                    (!cte.deliveryLatitude || !cte.deliveryLongitude)
                    ? (
                      <p className="ManifestsInTransit--p">Latitude ou longitude de confirmação de entrega não recebida.</p>
                    )
                    : null
                  }
                  {
                    (cte.deliveryLatitude && cte.deliveryLongitude)
                    ? (
                      <Button
                        className="ManifestsInTransit-Ctes__Button"
                        small
                        type="button"
                        skin="primary"
                        text="Visualizar no mapa"
                        onClick={() => this._openMap(cte.deliveryLatitude, cte.deliveryLongitude)}
                      />
                    )
                    : null
                  }
                </div>
                <div className="ManifestsInTransit--col">
                  <p className="ManifestsInTransit--p ManifestsInTransit--label">Duração</p>
                  <p className="ManifestsInTransit--p">{this.calculateDeliveryDuration(cte.unloadDate, cte.checkInDate)}</p>
                </div>
              </div>
              <div className="ManifestsInTransit--row-title">
                <h2 className="ManifestsInTransit--title">Nfs</h2>
              </div>
              <Accordion
                duration={0}
              >
                {cte.documents && cte.documents.map(nf => (
                  <AccordionItem
                    key={nf.nf}
                    className="NFTooltip__accordion-item"
                    bodyClassName="NFTooltip__accordion-item-body NFTooltip__accordion-item-outside padding"
                    title={`NF-${nf.nf}-${nf.nfGroup}`}
                    expanded
                  >
                    <div className="ManifestsInTransit--row">
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">CNPJ de ddestino:</p>
                        <p className="ManifestsInTransit--p">{nf.cnpjDest}</p>
                      </div>
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">Endereço:</p>
                        <p className="ManifestsInTransit--p">{`${nf.destinationAddress.address}${nf.destinationAddress.number || ''} - ${nf.destinationAddress.neighborhood}`}</p>
                      </div>
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">Cidade/Estado:</p>
                        <p className="ManifestsInTransit--p">{`${nf.destinationAddress.city}/${nf.destinationAddress.stateAbbr}`}</p>
                      </div>
                    </div>
                    <div className="ManifestsInTransit--row">
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">data:</p>
                        <p className="ManifestsInTransit--p">{nf.nfDate ? moment(nf.nfDate).format('DD/MM/YYYY') : ''}</p>
                      </div>
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">Valor:</p>
                        <p className="ManifestsInTransit--p">{nf.nfValue}</p>
                      </div>
                      <div className="ManifestsInTransit--col">
                        <p className="ManifestsInTransit--p ManifestsInTransit--label">Peso:</p>
                        <p className="ManifestsInTransit--p">{intl.formatNumber(nf.nfWeight)}</p>
                      </div>
                    </div>
                  </AccordionItem>
                ))}
              </Accordion>
            </AccordionItem>
          ))}
        </Accordion>
        {
          showMapModal
          ? (
            <Modal
              title="Localização atual"
              onBackdropClick={() => this.setState({ showMapModal: false })}
            >
              <Map
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div className="ManifestsInTransit-Ctes__loading-el" />}
                latitude={currentLatitude}
                longitude={currentLongitude}
                containerElement={<div className="ManifestsInTransit-Ctes__container-el" />}
                mapElement={<div className="ManifestsInTransit-Ctes__map-el" />}
                isKeyAccount={false}
                shippingGroupId={1}
                performanceStatusCode={1}
                defaultZoom={11}
              />
            </Modal>
          )
          : null
        }
      </div>
    );
  }
}

export default injectIntl(Ctes);
